import { AxiosPromise } from 'axios'

import api from '@config/api-mrp'

import {
  IApprovalRequest,
  IPendingOrdersFilterRequest
} from '@base/@types/providers/Mrp/ApprovalProvider'

interface IGetPurchaseData {
  page?: number
  params: { [key: string]: number[] | boolean | string | number | any[] | any }
  isProgramada?: boolean
}
interface IUploadData {
  file?: any
  params: {
    [key: string]: number[] | boolean | string | number | any[] | any | Blob
  }
}

export function getCenters(): AxiosPromise {
  return api.get('v1/Loja')
}

export function getCategories(): AxiosPromise {
  return api.get('v1/Categoria')
}

export function getCompanies(): AxiosPromise {
  return api.get('v1/Empresa')
}
export function getCompactCategories(): AxiosPromise {
  return api.get('v1/CategoriaCompacta')
}

export function getWorlds(): AxiosPromise {
  return api.get('v1/Mundo')
}

export function getDistributionCenters(): AxiosPromise {
  return api.get('v1/Loja/CentroDistribuicao')
}

export function getSuppliersForPurschase(): AxiosPromise {
  return api.get('v1/Fornecedor')
}

export function getSuppliersForDistribution(): AxiosPromise {
  return api.get('v1/Fornecedor')
}

export function getProductsForPurschase(): AxiosPromise {
  return api.get('v1/Produto/Compras')
}

export function getProductsForDistribution(): AxiosPromise {
  return api.get('v1/Produto/Distribuicoes')
}

export function completeMinimumOrderSupplier(data: any): AxiosPromise {
  return api.put('v1/Fornecedor/Pedidos/Minimo', {
    recomendacaoFornecimentos: data
  })
}

export function getSupplyMethods(): AxiosPromise {
  return api.get('v1/Fornecedor/Metodos/Pagamentos')
}
export function getDiscountSupply(data: any): AxiosPromise {
  return api.post('v1/Fornecedor/Descontos', data)
}
export function getSuppliersResume(
  data: any[],
  isProgramada = false
): AxiosPromise {
  return api.post(
    `/v1${isProgramada ? '/Programada' : '/Compra'}/Resumo/Fornecedores`,
    {
      resumoCompraFornecedorCommand: data
    }
  )
}

export function getHistoricSapProtocol(
  code: any,
  page: any,
  take: any,
  start?: string,
  end?: string,
  idUser?: string
): AxiosPromise {
  // Criação do objeto base com tipoProcesso
  const requestBody: any = {
    tiposProcessos: [Number(code)]
  }

  // Adiciona dataInicio e dataFim se start e end estiverem preenchidos
  if (start && end) {
    requestBody.dataInicio = start
    requestBody.dataFim = end
  }

  // Adiciona idUser se estiver preenchido
  if (idUser) {
    requestBody.usuariosIds = [Number(idUser)]
  }
  requestBody.statusPedidos = []
  requestBody.lojasIds = []
  requestBody.pedidosIds = []
  requestBody.produtosIds = []
  // Faz a requisição com o corpo configurado
  return api.post('/v1/PedidoSapMRP/Protocolos/Unificado', requestBody, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: take
      })
    }
  })
}
export function getHistoricSap(
  code: any,
  page: any,
  take: any,
  start?: string,
  end?: string,
  idUser?: string
): AxiosPromise {
  // Criação do objeto base com tipoProcesso
  const requestBody: any = {
    tipoProcesso: code
  }

  // Adiciona dataInicio e dataFim se start e end estiverem preenchidos
  if (start && end) {
    requestBody.dataInicio = start
    requestBody.dataFim = end
  }

  // Adiciona idUser se estiver preenchido
  if (idUser) {
    requestBody.idUser = idUser
  }
  // Faz a requisição com o corpo configurado
  return api.post('/v1/PedidoSapMRP', requestBody, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: take
      })
    }
  })
}

export function getHistoricPurchaseProcess(obj: any): AxiosPromise {
  // Criação do objeto base com tipoProcesso

  // Faz a requisição com o corpo configurado
  return api.post('/v1/PedidoSapMRP/Protocolos/Unificado', obj, {})
}
export function getHistoricSapExport(
  code: any,
  start: any,
  end: any,
  idUser?: any
): AxiosPromise {
  const body = {
    tipoProcesso: code,
    dataInicio: start,
    dataFim: end,
    ...(idUser ? { idUser } : {}) // ✅ adiciona userId se não for null, undefined ou vazio
  }

  return api.post('/v1/PedidoSapMRP/Exportar', body)
}

export function uploadPurchase({
  file: fileUpload,
  params: filters
}: IUploadData): AxiosPromise {
  const formData = new FormData()
  formData.append('file', fileUpload)
  formData.append('request', JSON.stringify(filters))
  return api.post('v1/RecomendacaoFornecimento/Arquivo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// COMPRA
export function getPurschaseData({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Compra', filters, {})
}

export function postPurshaseExport({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Compra/Exportar', filters, {})
}
export function postPurshaseExportSap({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Compra/Pedido/SAP', filters, {})
}

export function postPurshaseExportSapCsv({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Compra/Exportar/SAP', filters, {})
}

export function putPurshaseWanted({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.put('v1/Compra/Desejada', filters, {})
}

export function postPurshaseProgrammedExport({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Programada/Filtro/Exportar  ', filters, {})
}
// FIM COMPRA

// COMPRA PROGRAMADA
export function getPurschaseProgramedData({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Programada', filters, {})
}

export function getSuppliersResumeProgramed(data: any[]): AxiosPromise {
  return api.post('v1/Programada/Resumo/Fornecedores', {
    resumoCompraFornecedorCommand: data
  })
}

export function postPurshaseProgramedExport({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Programada/Exportar', filters, {})
}

export function postPurshaseProgramedUnicExportSap({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Programada/Unico/Pedido/Sap', filters, {})
}

export function postPurshaseProgramedUnicExportSapCsv({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Programada/Exportar/SAP/Unico', filters, {})
}

export function postPurshaseProgramedExportSap({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('/v1/Programada/Programacao/Pedido/Sap', filters, {})
}

export function postPurshaseProgramedExportSapCsv({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('/v1/Programada/Exportar/SAP/Programacao', filters, {})
}
// FIM COMPRA PROGRAMADA
export function getReabData({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/ReabEmergencial', filters, {})
}

export function getOportunityData({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Oportunidade', filters)
}

export function getOportunityDiscountsData({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Oportunidade/Descontos', filters)
}
// DISTRIBUIÇÂO
export function getDistributionData({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Distribuicao', filters, {})
}

export function postDistributionExport({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Compra/Exportar', filters, {})
}
export function postDistributionExportSap({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Distribuicao/Pedido/SAP', filters, {})
}

export function postDistributionExportSapCsv({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Distribuicao/Exportar/SAP', filters, {})
}

export function postDistributionExportSapFormatada({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Distribuicao/Pedido/Formatada/SAP', filters, {})
}

export function postDistributionExportSapFormatadaCsv({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Distribuicao/Exportar/Formatada/SAP', filters, {})
}

// END DISTRIBUIÇÂO
export function getSalesChart(
  storeId: number,
  productId: number
): AxiosPromise {
  return api.get(
    `/v1/Loja/VendasDiarias/Dashboard/${productId}/Produtos/${storeId}/Lojas`
  )
}

export function getStorageChart(
  storeId: number,
  productId: number
): AxiosPromise {
  return api.get(
    `/v1/Estoque/Movimentos/Dashboard/${productId}/Produtos/${storeId}/Lojas`
  )
}

export function getPurschaseCardsData({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/Compra/Cards', filters, {})
}

// REAB

export function postReabExport({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/ReabEmergencial/Exportar', filters, {})
}
export function postReabExportSap({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/ReabEmergencial/Pedido/SAP', filters, {})
}

export function postReabExportSapCsv({
  params: filters
}: IGetPurchaseData): AxiosPromise {
  return api.post('v1/ReabEmergencial/Exportar/SAP', filters, {})
}

export function getPurchasseProcess(): AxiosPromise {
  return api.get('v1/PedidoSapMRP/Protocolos/Alertas', {})
}

export function postMarkViewHistoric(): AxiosPromise {
  return api.post('v1/PedidoSapMRP/Protocolos/Alertas/MarcarComoVisto', {}, {})
}
// END REAB

export function getVendaMediaMovelDetalhe(
  produtoId: number,
  lojaId: number
): AxiosPromise {
  return api.get('v1/RecomendacaoFornecimento/VendaMediaMovel/Detalhe', {
    params: { ProdutoId: produtoId, LojaId: lojaId }
  })
}

// APROVAÇÃO DE PEDIDOS
export function postFilterPendingOrders(
  data: IPendingOrdersFilterRequest
): AxiosPromise {
  return api.post('v1/PedidoSapMRP/Pendentes/Filtrar', data)
}

export function postApproveOrder({
  idRequestSap,
  aprovar,
  justificativa,
  observacao,
  quantidadeAjustadas,
  enviadoComFalha
}: IApprovalRequest): AxiosPromise {
  return api.put(`v1/PedidoSapMRP/Pendentes/${idRequestSap}`, {
    idRequestSap,
    aprovar,
    justificativa,
    observacao,
    quantidadeAjustadas,
    enviadoComFalha
  })
}

export function getMrpDetailsById(id: string): AxiosPromise {
  return api.get(`v1/PedidoSapMRP/Pendentes/${id}`)
}

export function postApproverOrder(data: any): AxiosPromise {
  return api.post('v1/PedidoSapMRP/Aprovador', data)
}
// END APROVAÇÃO DE PEDIDOS

export default {
  getCenters,
  getCompanies,
  getCategories,
  getCompactCategories,
  getWorlds,
  getSuppliersResume,
  getSuppliersForPurschase,
  getSuppliersForDistribution,
  getProductsForPurschase,
  getProductsForDistribution,
  getDistributionCenters,
  getPurschaseData,
  getOportunityData,
  getReabData,
  getDistributionData,
  uploadPurchase,
  getSalesChart,
  postReabExport,
  postReabExportSap,
  postPurshaseExportSap,
  postDistributionExportSap,
  postDistributionExportSapFormatada,
  getPurschaseCardsData,
  completeMinimumOrderSupplier,
  putPurshaseWanted,
  getDiscountSupply,
  postPurshaseExport,
  postDistributionExport,
  postPurshaseProgramedExport,
  postPurshaseProgrammedExport,
  getSupplyMethods,
  postPurshaseProgramedExportSap,
  getOportunityDiscountsData,
  postPurshaseProgramedUnicExportSap,
  getPurschaseProgramedData,
  postPurshaseExportSapCsv,
  getStorageChart,
  getHistoricSap,
  getHistoricSapExport,
  postDistributionExportSapCsv,
  postDistributionExportSapFormatadaCsv,
  postPurshaseProgramedExportSapCsv,
  postPurshaseProgramedUnicExportSapCsv,
  postReabExportSapCsv,
  getHistoricPurchaseProcess,
  getPurchasseProcess,
  getHistoricSapProtocol,
  postMarkViewHistoric,
  postFilterPendingOrders,
  postApproveOrder,
  postApproverOrder,
  getMrpDetailsById,
  getVendaMediaMovelDetalhe
}
